import { getEnumValues } from '@jotta/utils/enum'

export enum Breakpoint {
  sm = 600, // Br1 in old theme
  md = 768, // extendedBreakpoints.tablet-sm in old theme
  lg = 1024, // Br2 in old theme
  xl = 1280,
  '2xl' = 1440, // Br3 in old theme
  '3xl' = 1600,
}

export default getEnumValues(Breakpoint)
